import React from 'react';

import { Form, Modal } from 'antd';
import { useTranslation } from 'react-i18next';

import { useAppSelector } from 'segments/hooks';
import { useNotification } from 'segments/hooks/useNotification';

import { InputStr, SubmiteButton } from 'shared/FormItems';
import { ModalFooter } from 'shared/Modals';

import { SelectCourt } from 'features/courts';
import { selectActiveBookingEditParams, UpdateCourtBookingParams, useUpdateCourtBookingMutation } from 'features/courtsBooking';

type FormData = Omit<UpdateCourtBookingParams, 'bookingId'>
interface Props {
  handleCancel: () => void;
}

export const EditCourtBooking = ({ handleCancel }: Props) => {
  const { t } = useTranslation();

  const editParams = useAppSelector(selectActiveBookingEditParams);
  const [form] = Form.useForm<FormData>();

  const [updateBooking, { isSuccess, isError, isLoading, error }] = useUpdateCourtBookingMutation();

  useNotification({
    isSuccess,
    isError,
    onSuccess: () => handleCancel(),
    onError: () => handleCancel(),
    error
  });

  if (editParams === null) {
    return;
  }

  const onFinish = (values: FormData) => {
    editParams.bookingIds.forEach((bookingId) => {
      updateBooking({
        bookingId,
        ...(values.note !== editParams.note && { note: values.note }),
        ...(values.courtId !== editParams.courtId && { courtId: values.courtId })
      });
    });
  };

  const modalTittle =
    `${t('courts.title.edit-booked-court')}`;
  return (
    <Modal
      title={modalTittle}
      open
      onCancel={handleCancel}
      destroyOnClose
      footer={[
        <ModalFooter
          key="modalFooter"
          handleCancel={handleCancel}
          resetFields={form.resetFields}
        />
      ]}
    >
      <Form
        name="basic"
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        initialValues={{
          note: editParams.note,
          courtId: editParams.courtId
        }}
      >
        <SelectCourt />
        <InputStr type='note' />
        <SubmiteButton submiteText={t('table.edit')} isLoading={isLoading} />
      </Form>
    </Modal >
  );
};
